import type { VFC } from 'react'
import { Asset } from '@opallabs/cassini'
import { Icon, Image } from '@opallabs/lapidary'
import * as styles from './styles'
import type { AvatarPreviewProps } from './types'

/**
 * Renders an avatar or a placeholder.
 */
export const AvatarPreview: VFC<AvatarPreviewProps> = ({
  dataUri,
  givenName,
  familyName,
  size,
  theme,
  uuid,
}) => {
  if (uuid) {
    return (
      <Asset
        assetReference={{
          uuid,
        }}
        preview={true}
        styleOverrides={styles.avatar({ size, theme })}
        transforms={{
          height: size,
          width: size,
        }}
      />
    )
  }

  if (typeof dataUri === 'string') {
    return (
      <Image
        alt=""
        ariaMode="hidden"
        src={dataUri}
        styleOverrides={styles.avatar({ size, theme })}
      />
    )
  }

  // @note This implementation is mostly-correct for western names (aside from
  //   things like tussenvoegsel), and mostly-incorrect for non-western names.
  //   The `<Avatar>` component has the same issue, though. At present Opal's
  //   customer base is heavily American so we can get away with this.
  const initials = [givenName, familyName]
    .map((name) => {
      return typeof name === 'string' ? (name[0] || '').toUpperCase() : ''
    })
    .join('')
  if (initials !== '') {
    return <span css={styles.avatar({ size, theme })}>{initials}</span>
  }

  const iconSize = size * 0.75
  return (
    <div css={styles.avatar({ size, theme })}>
      <Icon
        ariaMode="hidden"
        glyph="gem-user"
        height={iconSize}
        width={iconSize}
      />
    </div>
  )
}
AvatarPreview.displayName = 'ExAstra: AvatarPreview ← Form ← AccountCreation'
